export default "__VITE_ASSET__ChnBQnZY__"